import { UntypedFormGroup } from '@angular/forms'

import { Clinician } from '../../model/clinician'
import { CustomQuestionSchema } from '../../schema'
import { PatientIntakeFormData } from '../intake-form-data.class'
import { QuestionBase } from './base.question.class'

export class ImageQuestion extends QuestionBase<string> {
  controlType = 'canvas'
  type = 'image'

  saveValueToData(
    data: PatientIntakeFormData,
    form: UntypedFormGroup,
    clinician: Clinician,
  ) {
    const customData: CustomQuestionSchema = {
      id: this.id,
      value: form.value[this.id].value,
      note: form.value[this.id].note,
      isImage: true,
    }

    data.saveCustomQuestion(customData, clinician.id)
  }
}
